<!-- 引导下载的悬浮窗 -->
<template>
  <!-- prettier-ignore -->
  <div class="load-box">
    <img
      class="download-code-img"
      :src="qrcodeImg || require('@assets/img/code_download.png')"
    />
    <p class="load-box__tips">{{ $t('lang024') }}</p>
    <div class="load-box__btns">
      <a
        class="btn btn1"
        href="https://itunes.apple.com/app/id1077137248"
      ></a>
      <a
        class="btn btn2"
        :href="apkDlLink"
      ></a>
      <a
        class="btn btn3"
        href="https://play.google.com/store/apps/details?id=sg.bigo.live"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    qrcodeImg: {
      type: String,
      default: ''
    },
    hideBigolive: Boolean
  },
  computed: {
    apkDlLink() {
      // 30282广告页不能出现bigolive.tv的链接
      if (this.hideBigolive) {
        return 'https://static-web.hzmk.site/as/bigo-static/apk/bigolive-bigotv.apk';
      } else {
        return 'https://static-web.hzmk.site/as/bigo-static/apk/bigolive-bigotv.apk';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.load-box {
  position: relative;
  width: 159px;
  box-sizing: content-box;
  background: #fff;
  padding-bottom: 12px;
  padding-top: 24px;
  border: 1.5px solid #e5e5e5;

  &::before {
    content: '';
    position: absolute;
    display: inline-block;
    top: -89px;
    left: 28px;
    width: 100px;
    height: 97px;
    background-image: url(~@assets/img/fix-bigo.png);
  }

  .download-code-img {
    display: block;
    width: 124px;
    margin: auto;
    margin-bottom: 5px;
  }

  &__tips {
    width: 100%;
    margin-bottom: 10px;
    padding: 0 5px;
    text-align: center;
    font-size: 12px;
    color: #c1c1c1;
    letter-spacing: 1px;
  }

  &__btns {
    width: 140px;
    overflow: hidden;
    margin: auto;
    margin-left: 24px;

    .btn {
      float: left;
      display: block;
      width: 20px;
      height: 22px;
      margin-right: 25px;
      color: #999;
      line-height: 22px;

      &::before {
        float: left;
        display: block;
        margin-left: 30px;
        color: #e2e2e2;
        font-size: 16px;
      }

      &.btn1 {
        background: url(~@assets/img/icon.png) -11px -991px no-repeat;

        &::before {
          content: '|';
        }

        &:hover {
          background: url(~@assets/img/icon.png) -47px -991px no-repeat;
        }
      }

      &.btn2 {
        background: url(~@assets/img/icon.png) -11px -1021px no-repeat;

        &::before {
          content: '|';
        }

        &:hover {
          background: url(~@assets/img/icon.png) -47px -1021px no-repeat;
        }
      }

      &.btn3 {
        background: url(~@assets/img/icon.png) -84px -991px no-repeat;

        &:hover {
          background: url(~@assets/img/icon.png) -84px -1021px no-repeat;
        }
      }
    }
  }
}
</style>
